
export const strongTranslationsIT = {
  "G11": {
    m: "Abramo",
    d: "Il patriarca Abramo, padre dei credenti.",
    u: "Usato 73 volte nel NT. Modello di fede.",
    e: "Dall'ebraico אַבְרָהָם (Abraham) = padre di una moltitudine"
  },
  "G25": {
    m: "amare con amore divino e incondizionato",
    d: "Amare con amore altruista, sacrificale e divino. Questo è l'amore che Dio ha per l'umanità e l'amore con cui i cristiani devono amarsi a vicenda.",
    u: "Usato 143 volte nel NT. Descrive l'amore divino, perfetto e incondizionato.",
    e: "Da ἄγω (ago) = condurre, guidare al bene"
  },
  "G26": {
    m: "amore divino, carità",
    d: "L'amore perfetto di Dio; amore fraterno, affetto, benevolenza, carità. L'amore che unisce Dio e l'uomo, e l'uomo al suo prossimo.",
    u: "Usato 116 volte nel NT. La parola centrale del cristianesimo per descrivere l'amore divino.",
    e: "Derivato da ἀγαπάω (agapao)"
  },
  "G27": {
    m: "amato, caro",
    d: "Amato, caro; amato da Dio o dagli uomini.",
    u: "Usato 61 volte nel NT. Il Figlio amato di Dio.",
    e: "Da ἀγαπάω (agapao) = amare"
  },
  "G32": {
    m: "angelo, messaggero",
    d: "Messaggero; angelo celeste al servizio di Dio.",
    u: "Usato 175 volte nel NT. Gli angeli di Dio.",
    e: "Da ἀγγέλλω (aggello) = annunciare"
  },
  "G36": {
    m: "di bassa nascita, ignobile",
    d: "Senza nobiltà, di bassa estrazione; disprezzato.",
    u: "Usato 1 volta nel NT (1 Cor 1:28).",
    e: "Da ἀ- (negativo) + γένος (genos) = nascita"
  },
  "G93": {
    m: "ingiustizia, iniquità",
    d: "Violazione del diritto, ingiustizia; malvagità, iniquità morale.",
    u: "Usato 25 volte nel NT. Contrario di δικαιοσύνη (giustizia).",
    e: "Da ἀ- (negativo) + δίκη (dike) = giustizia"
  },
  "G154": {
    m: "chiedere, pregare, supplicare",
    d: "Chiedere, pregare per qualcosa, supplicare, petizionare. Richiesta umile e rispettosa.",
    u: "Usato 70 volte nel NT. Richiesta rivolta a Dio o agli uomini.",
    e: "Da αἰτέω (aiteo) radice primitiva; chiedere"
  },
  "G166": {
    m: "eterno, perpetuo",
    d: "Senza inizio né fine, che esiste sempre; nel NT, spesso legato alla vita eterna in Dio.",
    u: "Usato 71 volte nel NT. Qualifica spesso la vita eterna e il regno di Dio.",
    e: "Da αἰών (aion) = età, epoca, eternità"
  },
  "G225": {
    m: "verità, realtà",
    d: "Ciò che è vero nelle cose riguardanti Dio e i doveri dell'uomo; la verità divina rivelata.",
    u: "Usato 109 volte nel NT. Concetto centrale dell'insegnamento di Gesù.",
    e: "Da ἀληθής (alethes) = vero, sincero"
  },
  "G281": {
    m: "amen, in verità",
    d: "Formula di affermazione: così sia, in verità, certamente.",
    u: "Usato 129 volte nel NT. Gesù dice 'In verità, in verità'.",
    e: "Dall'ebraico אָמֵן (amen) = fermo, fedele"
  },
  "G444": {
    m: "uomo, essere umano",
    d: "Essere umano, uomo o donna; l'umanità in generale.",
    u: "Usato 550 volte nel NT. L'uomo creato a immagine di Dio.",
    e: "Da ἀνήρ (aner) = uomo e ὤψ (ops) = volto"
  },
  "G622": {
    m: "perdere, distruggere, perire",
    d: "Distruggere completamente; perdere, perire; essere rovinato.",
    u: "Usato 90 volte nel NT. Salvare ciò che era perduto.",
    e: "Da ἀπό (apo) = da + ὄλλυμι (ollumi) = distruggere"
  },
  "G649": {
    m: "inviare, delegare",
    d: "Inviare con una missione; delegare come ambasciatore.",
    u: "Usato 132 volte nel NT. Il Padre invia il Figlio.",
    e: "Da ἀπό (apo) = da + στέλλω (stello) = inviare"
  },
  "G721": {
    m: "agnello",
    d: "Piccolo agnello; designa Gesù Cristo come l'Agnello di Dio.",
    u: "Usato 30 volte nel NT, soprattutto nell'Apocalisse.",
    e: "Diminutivo di ἀρήν (aren) = agnello"
  },
  "G730": {
    m: "maschio, maschile",
    d: "Di sesso maschile, maschio.",
    u: "Usato 9 volte nel NT. Dio creò l'uomo maschio e femmina.",
    e: "Radice primaria"
  },
  "G740": {
    m: "pane",
    d: "Pane, cibo; il pane della vita = Cristo.",
    u: "Usato 97 volte nel NT. Gesù il pane della vita.",
    e: "Da ἄρω (aro) = sollevare, alzare"
  },
  "G746": {
    m: "principio, inizio",
    d: "Il principio, origine, primo principio. In Giovanni 1:1-2, designa l'inizio eterno dove già esisteva la Parola (Logos).",
    u: "Usato 55 volte nel NT. Parola chiave di Giovanni 1:1 'Nel principio era la Parola'.",
    e: "Parola primaria; principio, origine prima"
  },
  "G772": {
    m: "debole, malato",
    d: "Senza forza, debole; malato, infermo; spiritualmente debole.",
    u: "Usato 25 volte nel NT. Dio sceglie i deboli del mondo.",
    e: "Da ἀ- (negativo) + σθένος (sthenos) = forza"
  },
  "G907": {
    m: "battezzare, immergere",
    d: "Immergere nell'acqua; battezzare per purificare o iniziare.",
    u: "Usato 77 volte nel NT. Il battesimo cristiano.",
    e: "Da βάπτω (bapto) = immergere, tuffare"
  },
  "G1080": {
    m: "generare, far nascere",
    d: "Generare, dare alla luce; nascere di nuovo spiritualmente.",
    u: "Usato 97 volte nel NT. Nascere da Dio, essere nato di nuovo.",
    e: "Radice primaria"
  },
  "G1096": {
    m: "diventare, accadere, avvenire",
    d: "Diventare, venire all'esistenza, accadere, aver luogo, verificarsi.",
    u: "Usato 678 volte nel NT. 'Tutte le cose sono state fatte per mezzo di lui' (Gv 1:3).",
    e: "Da γίνομαι (ginomai) = diventare"
  },
  "G1097": {
    m: "conoscere, sapere, comprendere",
    d: "Conoscere per esperienza personale; comprendere, percepire, essere consapevole di.",
    u: "Usato 222 volte nel NT. Conoscenza esperienziale, non solo intellettuale.",
    e: "Radice indoeuropea *gen- = generare, conoscere"
  },
  "G1100": {
    m: "lingua, linguaggio",
    d: "Organo della parola; linguaggio, dialetto; dono delle lingue.",
    u: "Usato 50 volte nel NT. Il dono delle lingue.",
    e: "Radice primaria"
  },
  "G1166": {
    m: "mostrare, dimostrare",
    d: "Esporre agli occhi, mostrare; provare, dimostrare.",
    u: "Usato 33 volte nel NT. Dio mostra la sua gloria.",
    e: "Radice primaria"
  },
  "G1208": {
    m: "secondo",
    d: "Il secondo in una serie o ordine.",
    u: "Usato 44 volte nel NT. Il secondo comandamento.",
    e: "Da δύο (duo) = due"
  },
  "G1271": {
    m: "intelligenza, pensiero",
    d: "La facoltà di pensare, udire, comprendere; la mente, la comprensione.",
    u: "Usato 12 volte nel NT. La mente rinnovata da Cristo.",
    e: "Da διά (dia) = attraverso + νοῦς (nous) = mente"
  },
  "G1320": {
    m: "insegnante, maestro, istruttore",
    d: "Insegnante, istruttore; colui che insegna verità religiose.",
    u: "Usato 59 volte nel NT. 'Rabbì, sappiamo che sei un maestro venuto da Dio' (Gv 3:2).",
    e: "Da διδάσκω (didasko) = insegnare"
  },
  "G1325": {
    m: "dare, concedere",
    d: "Dare qualcosa a qualcuno; concedere, permettere; consegnare.",
    u: "Usato 415 volte nel NT. Dio dà generosamente.",
    e: "Radice primaria"
  },
  "G1372": {
    m: "aver sete, desiderare ardentemente",
    d: "Soffrire la sete; desiderare ardentemente, aspirare a.",
    u: "Usato 16 volte nel NT. Sete spirituale di Dio.",
    e: "Da δίψα (dipsa) = sete"
  },
  "G1401": {
    m: "schiavo, servo",
    d: "Schiavo, servo; servo volontario di Dio.",
    u: "Usato 124 volte nel NT. Servi di Cristo.",
    e: "Da δέω (deo) = legare"
  },
  "G1411": {
    m: "potenza, forza, miracolo",
    d: "Forza, potere, capacità; atto di potenza, miracolo.",
    u: "Usato 120 volte nel NT. La potenza di Dio, dello Spirito Santo.",
    e: "Da δύναμαι (dunamai) = essere capace"
  },
  "G1417": {
    m: "due",
    d: "Il numero due; una coppia.",
    u: "Usato 135 volte nel NT. Due o tre testimoni.",
    e: "Radice primaria"
  },
  "G1473": {
    m: "io",
    d: "Pronome personale di prima persona singolare.",
    u: "Usato 2567 volte nel NT. Molto frequente.",
    e: "Pronome primario"
  },
  "G1484": {
    m: "nazione, popolo, gentili",
    d: "Popolo, nazione; le nazioni pagane (non ebrei).",
    u: "Usato 162 volte nel NT. Il vangelo per tutte le nazioni.",
    e: "Radice primaria"
  },
  "G1492": {
    m: "sapere, vedere, conoscere",
    d: "Sapere per percezione, vedere, capire, conoscere. Conoscenza acquisita attraverso esperienza o rivelazione.",
    u: "Usato 666 volte nel NT. Verbo fondamentale della conoscenza nel Vangelo di Giovanni.",
    e: "Forma perfetta di εἴδω (eido); vedere, sapere"
  },
  "G1510": {
    m: "essere, esistere",
    d: "Verbo essere in tutti i suoi sensi; esistere, rimanere, aver luogo.",
    u: "Il verbo più usato nel NT (2460+ volte).",
    e: "Radice primaria"
  },
  "G1515": {
    m: "pace",
    d: "Stato di tranquillità; pace con Dio; armonia tra le persone.",
    u: "Usato 92 volte nel NT. La pace di Cristo.",
    e: "Da εἴρω (eiro) = unire, legare"
  },
  "G1520": {
    m: "uno, unico",
    d: "Uno solo; unico, solamente; un certo.",
    u: "Usato 344 volte nel NT. L'unità di Dio, la chiesa unita.",
    e: "Radice primaria"
  },
  "G1586": {
    m: "scegliere, eleggere",
    d: "Scegliere per sé, selezionare; eleggere per grazia divina.",
    u: "Usato 21 volte nel NT. Dio elegge i suoi figli.",
    e: "Da ἐκ (ek) = da + λέγω (lego) = scegliere"
  },
  "G1658": {
    m: "libero, affrancato",
    d: "Libero, non schiavo; liberato dalla schiavitù del peccato.",
    u: "Usato 23 volte nel NT. Liberati in Cristo.",
    e: "Probabilmente da ἔρχομαι (erchomai) = venire"
  },
  "G1672": {
    m: "greco, gentile",
    d: "Un greco di nascita o di lingua; un non ebreo.",
    u: "Usato 25 volte nel NT. Né giudeo né greco in Cristo.",
    e: "Da Ἑλλάς (Hellas) = Grecia"
  },
  "G1680": {
    m: "speranza, attesa fiduciosa",
    d: "Attesa di cose buone, speranza fondata su Dio; fiducia nel futuro basata sulle promesse divine.",
    u: "Usato 54 volte nel NT. Una delle tre virtù teologali con la fede e l'amore.",
    e: "Da ἔλπω (elpo) = attendere, sperare"
  },
  "G1743": {
    m: "fortificare, rendere forte",
    d: "Rendere forte, fortificare; dare potenza.",
    u: "Usato 8 volte nel NT. Dio fortifica i credenti.",
    e: "Da ἐν (en) = in + δυναμόω (dynamoo) = rendere potente"
  },
  "G1746": {
    m: "rivestire, vestirsi",
    d: "Mettere un vestito; rivestirsi di una qualità o di un potere.",
    u: "Usato 27 volte nel NT. Rivestire Cristo, rivestire l'armatura di Dio.",
    e: "Da ἐν (en) = in + δύω (duo) = entrare, rivestire"
  },
  "G1785": {
    m: "comandamento, ordine",
    d: "Un ordine, comandamento, precetto; specialmente un comandamento divino.",
    u: "Usato 67 volte nel NT. I comandamenti di Dio e di Cristo.",
    e: "Da ἐντέλλομαι (entellomai) = comandare"
  },
  "G1848": {
    m: "disprezzare, trattare con disprezzo",
    d: "Considerare come nulla, disprezzare; trattare con disdegno.",
    u: "Usato 11 volte nel NT. Il mondo disprezza ciò che Dio sceglie.",
    e: "Da ἐξ (ex) = da + οὐθείς (outheis) = nessuno"
  },
  "G2041": {
    m: "opera, lavoro, atto",
    d: "Lavoro, fatica; azione, atto; opera compiuta.",
    u: "Usato 169 volte nel NT. Le opere di Dio, le buone opere.",
    e: "Da ἔργω (ergo) = lavorare"
  },
  "G2048": {
    m: "deserto, solitario",
    d: "Luogo deserto, wilderness; solitario, spopolato.",
    u: "Usato 48 volte nel NT. I 40 giorni di Gesù nel deserto.",
    e: "Da ἔρημος (eremos) = abbandonato"
  },
  "G2065": {
    m: "domandare, interrogare, chiedere",
    d: "Domandare, interrogare, chiedere informazioni. Inchiesta o investigazione.",
    u: "Usato 63 volte nel NT. Domandare per ottenere risposte.",
    e: "Radice incerta; domandare, interrogare"
  },
  "G2189": {
    m: "inimicizia, ostilità",
    d: "Odio, ostilità, inimicizia.",
    u: "Usato 6 volte nel NT. L'inimicizia con Dio abolita.",
    e: "Da ἐχθρός (echthros) = nemico"
  },
  "G2205": {
    m: "zelo, gelosia, invidia",
    d: "Ardore appassionato; può essere positivo (zelo per Dio) o negativo (gelosia, invidia).",
    u: "Usato 16 volte nel NT. Può essere virtuoso o vizioso secondo il contesto.",
    e: "Da ζέω (zeo) = bollire, essere fervente"
  },
  "G2222": {
    m: "vita",
    d: "Vita fisica o spirituale; la vita eterna in Dio.",
    u: "Usato 135 volte nel NT. Gesù è la vita.",
    e: "Da ζάω (zao) = vivere"
  },
  "G2258": {
    m: "era, egli era",
    d: "Era, egli era, ella era. Forma imperfetta del verbo essere (εἰμί). Esprime uno stato o esistenza nel passato.",
    u: "Usato 267 volte nel NT. Cruciale in Giovanni 1:1 'Nel principio era il Verbo'.",
    e: "Imperfetto di εἰμί (eimi) = essere; era"
  },
  "G2296": {
    m: "meravigliarsi, stupirsi, ammirare",
    d: "Meravigliarsi, stupirsi, essere stupito, ammirare. Reazione di meraviglia di fronte a qualcosa di straordinario.",
    u: "Usato 43 volte nel NT. Reazione frequente ai miracoli e agli insegnamenti di Gesù.",
    e: "Da θαῦμα (thauma) = meraviglia; meravigliarsi"
  },
  "G2316": {
    m: "Dio, divinità",
    d: "La Divinità suprema - specialmente (con l'articolo) l'unico vero Dio. Nella Scrittura, rivela l'unico Dio che si manifesta come Padre, Figlio e Spirito Santo, senza divisione dell'essenza divina.",
    u: "Usato 1343 volte nel NT secondo fonti bibliche. Parola centrale che designa l'unico vero Dio.",
    e: "Di affinità incerta secondo Strong. Designa una divinità, particolarmente la Divinità suprema. Uso biblico: rivela il Dio vivente che agisce nella storia della salvezza."
  },
  "G2338": {
    m: "femmina, femminile",
    d: "Di sesso femminile, femmina.",
    u: "Usato 5 volte nel NT. Uomo e donna uguali in Cristo.",
    e: "Da θηλάζω (thelazo) = allattare"
  },
  "G2362": {
    m: "trono",
    d: "Seggio regale, trono; potere e autorità regale.",
    u: "Usato 62 volte nel NT. Il trono di Dio e dell'Agnello.",
    e: "Radice primaria"
  },
  "G2381": {
    m: "Tommaso",
    d: "Tommaso, nome proprio. Uno dei dodici apostoli, chiamato anche Didimo (gemello). Conosciuto per aver chiesto prove della risurrezione.",
    u: "Usato 11 volte nel NT. L'apostolo che dubitò e poi credette.",
    e: "Dall'aramaico תְּאוֹמָא (teoma) = gemello"
  },
  "G2398": {
    m: "proprio, particolare, personale",
    d: "Proprio, particolare, personale, privato. Ciò che appartiene propriamente a qualcuno, distinto dagli altri.",
    u: "Usato 114 volte nel NT. Concetto di appartenenza personale e distinzione.",
    e: "Da radice incerta; proprio, particolare"
  },
  "G2424": {
    m: "Gesù",
    d: "Gesù di Nazareth, il Messia, il Salvatore.",
    u: "Usato 917 volte nel NT. Il nome al di sopra di ogni nome.",
    e: "Dall'ebraico יְהוֹשֻׁעַ (Yehoshua) = YHWH salva"
  },
  "G2453": {
    m: "giudeo, ebreo",
    d: "Appartenente alla razza ebraica; abitante della Giudea.",
    u: "Usato 195 volte nel NT. I giudei, popolo eletto di Dio.",
    e: "Da Ἰούδας (Ioudas) = Giuda"
  },
  "G2491": {
    m: "Giovanni",
    d: "Giovanni, nome proprio. Giovanni Battista il precursore, Giovanni l'apostolo amato, autore del Vangelo e delle epistole.",
    u: "Usato 135 volte nel NT. Nome di due grandi figure del NT.",
    e: "Dall'ebraico יוֹחָנָן (Yochanan) = YHWH è misericordioso"
  },
  "G2531": {
    m: "come, secondo che",
    d: "Come, nello stesso modo che; secondo che, nella misura in cui.",
    u: "Usato 182 volte nel NT. Congiunzione comparativa.",
    e: "Da κατά (kata) = secondo + ὡς (hos) = come"
  },
  "G2537": {
    m: "nuovo, recente",
    d: "Nuovo nel tempo o nella qualità; fresco, recente, non usato.",
    u: "Usato 42 volte nel NT. Nuova creazione, nuovo comandamento.",
    e: "Radice incerta"
  },
  "G2570": {
    m: "buono, bello",
    d: "Buono nella sua natura, bello; onorevole, eccellente, virtuoso.",
    u: "Usato 100 volte nel NT. Il buon pastore, le buone opere.",
    e: "Radice primaria"
  },
  "G2588": {
    m: "cuore",
    d: "Il cuore fisico; il centro della vita interiore, l'anima, lo spirito; i pensieri e i sentimenti.",
    u: "Usato 156 volte nel NT. Sede della vita spirituale.",
    e: "Radice primaria"
  },
  "G2596": {
    m: "secondo, contro, attraverso",
    d: "Preposizione con vari sensi: secondo, conformemente a; contro; attraverso.",
    u: "Usato oltre 470 volte nel NT. Preposizione molto frequente.",
    e: "Preposizione primaria"
  },
  "G2617": {
    m: "far vergognare, disonorare",
    d: "Far vergognare, disonorare; confondere, umiliare.",
    u: "Usato 13 volte nel NT. Dio confonde i saggi del mondo.",
    e: "Da κατά (kata) = contro + αἰσχύνω (aischuno) = aver vergogna"
  },
  "G2744": {
    m: "gloriarsi, vantarsi",
    d: "Gloriarsi, vantarsi; trovare il proprio orgoglio in qualcosa.",
    u: "Usato 37 volte nel NT. Gloriarsi nel Signore.",
    e: "Da καῦχος (kauchos) = vanteria"
  },
  "G2889": {
    m: "mondo, universo, umanità",
    d: "L'ordine del mondo, l'universo; l'umanità decaduta; il sistema opposto a Dio.",
    u: "Usato 186 volte nel NT. Può designare la creazione o il sistema peccatore.",
    e: "Da κοσμέω (kosmeo) = ornare, ordinare"
  },
  "G2919": {
    m: "giudicare, decidere",
    d: "Giudicare, pronunciare un giudizio; decidere, determinare.",
    u: "Usato 114 volte nel NT. Dio giudica il mondo.",
    e: "Radice primaria"
  },
  "G2920": {
    m: "giudizio, giustizia, condanna",
    d: "Giudizio, giustizia, condanna, decisione giudiziaria. Il giudizio di Dio, giusto e perfetto.",
    u: "Usato 47 volte nel NT. Concetto centrale della giustizia divina.",
    e: "Da κρίνω (krino) = giudicare, decidere"
  },
  "G2962": {
    m: "Signore, Maestro, proprietario",
    d: "Signore, Maestro; titolo di rispetto e autorità divina; Gesù come Signore.",
    u: "Usato 748 volte nel NT. 'Tommaso gli disse: Signore, non sappiamo dove vai' (Gv 14:5).",
    e: "Da κύριος (kurios) = avere autorità"
  },
  "G2992": {
    m: "popolo",
    d: "Un popolo, una nazione; specialmente il popolo di Dio (Israele o la Chiesa).",
    u: "Usato 142 volte nel NT. Il popolo eletto di Dio.",
    e: "Radice primaria"
  },
  "G3022": {
    m: "bianco, splendente",
    d: "Bianco, sfolgorante; simbolo di purezza e vittoria.",
    u: "Usato 25 volte nel NT. Le vesti bianche dei redenti.",
    e: "Da λευκός (leukos) = bianco, luminoso"
  },
  "G3056": {
    m: "parola, verbo, ragione",
    d: "Parola pronunciata; ragione, intelligenza; il Logos = Cristo.",
    u: "Usato 330 volte nel NT. Il Logos incarnato.",
    e: "Da λέγω (lego) = dire"
  },
  "G3101": {
    m: "discepolo, allievo",
    d: "Un apprendista, studente, discepolo; seguace di Gesù.",
    u: "Usato 261 volte nel NT. Designa i seguaci di Cristo.",
    e: "Da μανθάνω (manthano) = imparare"
  },
  "G3141": {
    m: "testimonianza, attestazione",
    d: "Testimonianza, attestazione, prova, evidenza. Testimonianza resa alla verità, particolarmente a Cristo.",
    u: "Usato 37 volte nel NT. Tema maggiore del Vangelo di Giovanni.",
    e: "Da μάρτυς (martus) = testimone"
  },
  "G3173": {
    m: "grande, importante",
    d: "Grande in dimensione, quantità o importanza; potente, meraviglioso.",
    u: "Usato 243 volte nel NT. La grandezza di Dio.",
    e: "Radice primaria"
  },
  "G3320": {
    m: "muro di separazione",
    d: "Muro divisorio, parete di separazione.",
    u: "Usato 1 volta nel NT (Ef 2:14). Il muro tra giudei e gentili.",
    e: "Da μέσος (mesos) = mezzo + τοῖχος (toichos) = muro"
  },
  "G3439": {
    m: "unico, unigenito",
    d: "Unico nel suo genere, unigenito; figlio unico.",
    u: "Usato 9 volte nel NT. Il Figlio unigenito di Dio.",
    e: "Da μόνος (monos) = solo + γίνομαι (ginomai) = diventare"
  },
  "G3474": {
    m: "follia, stoltezza",
    d: "Follia, assurdità; ciò che manca di saggezza.",
    u: "Usato 5 volte nel NT. La sapienza di Dio appare follia al mondo.",
    e: "Da μωρός (moros) = folle, insensato"
  },
  "G3475": {
    m: "Mosè",
    d: "Mosè, il legislatore d'Israele.",
    u: "Usato 80 volte nel NT. La legge di Mosè.",
    e: "Dall'ebraico מֹשֶׁה (Mosheh) = tratto (dalle acque)"
  },
  "G3530": {
    m: "Nicodemo",
    d: "Nicodemo, nome proprio. Fariseo e capo giudeo che venne a Gesù di notte. Nome greco che significa 'vittoria del popolo'.",
    u: "Usato 5 volte nel NT. Personaggio importante nel Vangelo di Giovanni.",
    e: "Dal greco νίκη (nikē) = vittoria e δῆμος (dēmos) = popolo"
  },
  "G3551": {
    m: "legge, Torah",
    d: "Legge, Torah, regola, principio. La legge di Mosè, la legge divina, i comandamenti di Dio.",
    u: "Usato 194 volte nel NT. Concetto centrale della rivelazione divina.",
    e: "Da νέμω (nemo) = distribuire, dare; legge data"
  },
  "G3571": {
    m: "notte",
    d: "Notte, periodo di buio tra il tramonto e l'alba. Spesso metaforico per l'ignoranza spirituale.",
    u: "Usato 61 volte nel NT. Contrapposto alla luce nel simbolismo giovanneo.",
    e: "Sostantivo femminile primario; notte"
  },
  "G3598": {
    m: "via, strada",
    d: "Strada, cammino; modo di vivere, condotta; la via della salvezza.",
    u: "Usato 101 volte nel NT. Gesù è la via.",
    e: "Radice primaria"
  },
  "G3609": {
    m: "domestico, della casa",
    d: "Appartenente alla casa, membro della famiglia; servitore domestico.",
    u: "Usato 3 volte nel NT. Descrive i membri della famiglia di Dio.",
    e: "Da οἶκος (oikos) = casa"
  },
  "G3664": {
    m: "simile, uguale",
    d: "Simile, della stessa natura o carattere; equivalente.",
    u: "Usato 45 volte nel NT. Il secondo comandamento simile al primo.",
    e: "Da ὁμός (homos) = stesso"
  },
  "G3686": {
    m: "nome",
    d: "Nome, titolo; reputazione; autorità, potere.",
    u: "Usato 228 volte nel NT. Il nome di Gesù.",
    e: "Radice primaria"
  },
  "G3708": {
    m: "vedere, guardare",
    d: "Vedere con gli occhi; percepire, comprendere; apparire.",
    u: "Usato 454 volte nel NT. Vedere Cristo, vedere il Padre.",
    e: "Radice primaria"
  },
  "G3735": {
    m: "monte, collina",
    d: "Montagna, monte; collina elevata.",
    u: "Usato 63 volte nel NT. Il monte della trasfigurazione.",
    e: "Probabilmente da ὁράω (horao) = vedere"
  },
  "G3756": {
    m: "non, no",
    d: "Negazione assoluta, no, non.",
    u: "Usato oltre 1600 volte nel NT. Particella negativa molto frequente.",
    e: "Particella primaria di negazione"
  },
  "G3762": {
    m: "nessuno, niente, nessun",
    d: "Nessuno, niente, nessun, neanche uno. Negazione assoluta di esistenza o quantità.",
    u: "Usato 234 volte nel NT. Negazione forte molto comune.",
    e: "Da οὐδέ (oude) e εἷς (heis); neanche uno"
  },
  "G3778": {
    m: "questo, questa, ciò",
    d: "Pronome dimostrativo: questo, questa, ciò. Designa qualcosa di vicino o menzionato in precedenza.",
    u: "Usato 1388 volte nel NT. Pronome dimostrativo più frequente.",
    e: "Pronome dimostrativo primario"
  },
  "G3789": {
    m: "serpente",
    d: "Serpente, rettile; il serpente antico (Satana).",
    u: "Usato 14 volte nel NT. Il serpente di bronzo nel deserto.",
    e: "Radice primaria"
  },
  "G3793": {
    m: "folla, moltitudine",
    d: "Folla di gente, moltitudine; la massa popolare.",
    u: "Usato 175 volte nel NT. Le folle che seguivano Gesù.",
    e: "Da ὄχος (ochos) = veicolo (che trasporta)"
  },
  "G3880": {
    m: "ricevere, prendere, accettare",
    d: "Ricevere, prendere, accettare, afferrare. Ricevere qualcosa che viene offerto o dato.",
    u: "Usato 59 volte nel NT. Concetto centrale dell'accettazione del Vangelo.",
    e: "Da παρά (para) = accanto e λαμβάνω (lambanō) = prendere"
  },
  "G3956": {
    m: "tutto, ogni",
    d: "Tutto, ogni, tutti; l'insieme, la totalità.",
    u: "Usato 1244 volte nel NT. Tra le parole più frequenti.",
    e: "Radice primaria"
  },
  "G3962": {
    m: "padre",
    d: "Un padre naturale o spirituale; antenato; Dio Padre.",
    u: "Usato 413 volte nel NT. Spesso per designare Dio.",
    e: "Radice primaria apparentata al latino 'pater'"
  },
  "G4100": {
    m: "credere, aver fede",
    d: "Aver fede in, credere; confidare in, appoggiarsi su.",
    u: "Usato 241 volte nel NT. Credere in Gesù per essere salvati.",
    e: "Da πίστις (pistis) = fede"
  },
  "G4102": {
    m: "fede, fiducia, fedeltà",
    d: "Convinzione della verità di qualcosa, credenza; nel NT di una convinzione riguardo al rapporto dell'uomo con Dio e le cose divine.",
    u: "Usato 244 volte nel NT. Concetto centrale della fede cristiana.",
    e: "Da πείθω (peitho) = persuadere, convincere"
  },
  "G4138": {
    m: "pienezza, abbondanza, ciò che riempie",
    d: "Pienezza, abbondanza, ciò che riempie completamente. La totalità, la completezza divina.",
    u: "Usato 17 volte nel NT. Concetto teologico della pienezza divina in Cristo.",
    e: "Da πλήρης (plērēs) = pieno; pienezza"
  },
  "G4139": {
    m: "prossimo, vicino",
    d: "Colui che è vicino, il vicino; il prossimo in generale.",
    u: "Usato 17 volte nel NT. 'Ama il tuo prossimo come te stesso'.",
    e: "Avverbio divenuto nome, da πλησίος (plesios) = vicino"
  },
  "G4151": {
    m: "spirito, soffio, vento",
    d: "Il soffio della vita, il principio vitale; l'anima razionale; lo Spirito Santo.",
    u: "Usato 385 volte nel NT. Designa lo Spirito Santo, lo spirito umano o degli spiriti.",
    e: "Da πνέω (pneo) = soffiare, respirare"
  },
  "G4160": {
    m: "fare, compiere, realizzare",
    d: "Fare, compiere, produrre, agire, creare. Verbo d'azione generale che copre ogni tipo di attività.",
    u: "Usato 568 volte nel NT. Verbo d'azione fondamentale, spesso nelle opere di Dio.",
    e: "Verbo primario; fare, compiere"
  },
  "G4166": {
    m: "pastore",
    d: "Colui che custodisce le pecore; custode spirituale, pastore di chiesa.",
    u: "Usato 18 volte nel NT. Gesù il buon pastore.",
    e: "Da ποίμνη (poimne) = gregge"
  },
  "G4183": {
    m: "molto, molti, grande",
    d: "Molto, molti, grande in quantità o numero. Moltitudine, grande quantità.",
    u: "Usato 416 volte nel NT. Aggettivo quantitativo molto frequente.",
    e: "Radice incerta; molto, molti"
  },
  "G4198": {
    m: "andare, camminare, viaggiare",
    d: "Andare, camminare, viaggiare, muoversi. Movimento da un luogo all'altro, spesso con uno scopo.",
    u: "Usato 154 volte nel NT. Verbo di movimento fondamentale nelle narrazioni evangeliche.",
    e: "Verbo primario; andare, camminare"
  },
  "G4238": {
    m: "fare, praticare, compiere",
    d: "Fare, praticare, compiere, agire. Compiere azioni, spesso con l'idea di ripetizione o abitudine.",
    u: "Usato 39 volte nel NT. Spesso collegato alla pratica del bene o del male.",
    e: "Forma rafforzata di πράω (praō); fare, praticare"
  },
  "G4263": {
    m: "pecora",
    d: "Pecora o montone; metaforicamente, i discepoli di Cristo.",
    u: "Usato 39 volte nel NT. I credenti come pecore del pastore.",
    e: "Probabilmente legato a προβαίνω (probaino) = avanzare"
  },
  "G4413": {
    m: "primo, principale",
    d: "Primo nel tempo, luogo, ordine o importanza.",
    u: "Usato 155 volte nel NT. Il primo comandamento, il primo posto.",
    e: "Superlativo di πρό (pro) = prima"
  },
  "G4561": {
    m: "carne, corpo",
    d: "Carne, carne; il corpo umano; la natura umana decaduta.",
    u: "Usato 147 volte nel NT. Contrasto tra carne e spirito.",
    e: "Radice primaria"
  },
  "G4592": {
    m: "segno, miracolo, prodigio",
    d: "Segno, miracolo, prodigio; manifestazione soprannaturale che rivela il potere divino.",
    u: "Usato 77 volte nel NT. 'perché nessuno può fare questi segni che tu fai' (Gv 3:2).",
    e: "Da σημεῖον (semeion) = segno, marca"
  },
  "G4648": {
    m: "guardare attentamente, mirare",
    d: "Fissare gli occhi su, considerare attentamente; avere in vista, mirare a uno scopo.",
    u: "Usato 6 volte nel NT. Appello a fissare gli occhi su Cristo.",
    e: "Legato a σκοπός (skopos) = bersaglio, scopo"
  },
  "G4680": {
    m: "saggio, dotto",
    d: "Saggio, intelligente, abile; formato, istruito.",
    u: "Usato 22 volte nel NT. La vera sapienza viene da Dio.",
    e: "Radice primaria"
  },
  "G4982": {
    m: "salvare, liberare",
    d: "Salvare da pericolo o distruzione; liberare dal peccato.",
    u: "Usato 106 volte nel NT. Gesù salva i peccatori.",
    e: "Da σῶς (sos) = sano e salvo"
  },
  "G5040": {
    m: "bambino piccolo",
    d: "Bambino piccolo, infante; termine affettuoso per discepolo.",
    u: "Usato 8 volte nel NT. Giovanni chiama i suoi lettori 'figlioletti'.",
    e: "Diminutivo di τέκνον (teknon) = bambino"
  },
  "G5087": {
    m: "porre, mettere, stabilire",
    d: "Mettere, collocare; stabilire, nominare; deporre, posare.",
    u: "Usato 100 volte nel NT. Deporre la propria vita per le pecore.",
    e: "Radice primaria"
  },
  "G5109": {
    m: "muro",
    d: "Muro di separazione, parete.",
    u: "Usato 1 volta nel NT (Atti 23:3).",
    e: "Radice primaria"
  },
  "G5207": {
    m: "figlio",
    d: "Discendente maschio; discepolo; membro di un gruppo. Il Figlio di Dio = Gesù Cristo.",
    u: "Usato 377 volte nel NT. Spesso per designare Gesù come Figlio di Dio.",
    e: "Origine incerta, forse legato a ὕω (huo) = far piovere, generare"
  },
  "G5281": {
    m: "pazienza, perseveranza, costanza",
    d: "Qualità di chi non cede alle circostanze o alle pressioni; perseveranza paziente, costanza.",
    u: "Usato 32 volte nel NT. Virtù cristiana essenziale.",
    e: "Da ὑπό (hupo) = sotto e μένω (meno) = rimanere"
  },
  "G5312": {
    m: "elevare, esaltare",
    d: "Alzare in alto, elevare; esaltare, onorare.",
    u: "Usato 20 volte nel NT. Il Figlio dell'uomo elevato.",
    e: "Da ὕψος (hupsos) = altezza"
  },
  "G5376": {
    m: "Filippo",
    d: "Filippo, nome proprio. Uno dei dodici apostoli. Nome greco che significa 'amante dei cavalli'.",
    u: "Usato 36 volte nel NT. Nome dell'apostolo e del diacono.",
    e: "Dal greco φίλος (philos) = amico e ἵππος (hippos) = cavallo"
  },
  "G5432": {
    m: "custodire, proteggere",
    d: "Custodire con una guardia militare; proteggere, preservare.",
    u: "Usato 4 volte nel NT. La pace di Dio custodisce i nostri cuori.",
    e: "Da φρουρός (phrouros) = guardia, sentinella"
  },
  "G5443": {
    m: "tribù, popolo",
    d: "Tribù, clan; un popolo discendente da un antenato comune.",
    u: "Usato 31 volte nel NT. Le dodici tribù d'Israele.",
    e: "Da φύω (phuo) = produrre, far crescere"
  },
  "G5457": {
    m: "luce",
    d: "Luce fisica o spirituale; la verità divina rivelata.",
    u: "Usato 73 volte nel NT. Gesù luce del mondo.",
    e: "Da φάω (phao) = brillare"
  },
  "G5463": {
    m: "rallegrarsi, essere gioioso",
    d: "Rallegrarsi, essere felice; saluto 'rallegrati' o 'salve'.",
    u: "Usato 74 volte nel NT. Comando frequente di rallegrarsi in Cristo.",
    e: "Apparentato a χάρις (charis) = grazia"
  },
  "G5495": {
    m: "mano",
    d: "La mano; potere, autorità; azione, opera.",
    u: "Usato 177 volte nel NT. La mano di Dio, le mani di Gesù.",
    e: "Radice primaria"
  },
  "G5544": {
    m: "bontà, benevolenza",
    d: "Bontà in azione, benevolenza pratica; qualità di chi è utile, vantaggioso per gli altri.",
    u: "Usato 10 volte nel NT. Frutto dello Spirito secondo Galati 5:22.",
    e: "Da χρηστός (chrestos) = buono, utile, benevolo"
  },
  "G5547": {
    m: "Cristo, Messia, Unto",
    d: "L'Unto, il Messia; titolo di Gesù come Salvatore promesso.",
    u: "Usato 529 volte nel NT. Gesù è il Cristo.",
    e: "Da χρίω (chrio) = ungere"
  },
  "G5590": {
    m: "anima, vita",
    d: "Il soffio della vita, l'anima vitale; la vita stessa; l'anima immortale.",
    u: "Usato 105 volte nel NT. La vita spirituale ed eterna.",
    e: "Da ψύχω (psucho) = respirare, rinfrescare"
  },
  "H120": {
    m: "uomo, umanità, Adamo",
    d: "Uomo, essere umano; l'umanità; Adamo il primo uomo.",
    u: "Usato 562 volte nell'AT. Dio creò l'uomo.",
    e: "Da אָדֹם (adom) = rosso, o אֲדָמָה (adamah) = terra"
  },
  "H160": {
    m: "amore, affetto",
    d: "Amore, affetto; atto d'amore.",
    u: "Usato 40 volte nell'AT. L'amore di Dio per il suo popolo.",
    e: "Da אָהַב (ahab) = amare"
  },
  "H216": {
    m: "luce",
    d: "Luce naturale o spirituale; felicità, prosperità.",
    u: "Usato 120 volte nell'AT. 'Sia la luce!'",
    e: "Da אוֹר (or) = essere luminoso"
  },
  "H430": {
    m: "Dio, dèi",
    d: "Il Dio supremo (Elohim); talvolta usato per i giudici o gli dèi pagani.",
    u: "Usato 2606 volte nell'AT. Nome plurale di maestà per Dio.",
    e: "Plurale di אֱלוֹהַּ (eloah) = dio"
  },
  "H559": {
    m: "dire, parlare",
    d: "Dire, parlare, dichiarare; comandare, pensare.",
    u: "Usato 5316 volte nell'AT. Il verbo di parola più frequente.",
    e: "Radice primaria"
  },
  "H776": {
    m: "terra, paese",
    d: "Terra, suolo; paese, regione; il mondo terrestre.",
    u: "Usato 2504 volte nell'AT. La terra che Dio creò.",
    e: "Radice primaria"
  },
  "H982": {
    m: "confidare, aver fiducia",
    d: "Confidare in, aver fiducia; essere al sicuro.",
    u: "Usato 120 volte nell'AT. Fiducia nel Signore.",
    e: "Radice primaria"
  },
  "H1004": {
    m: "casa, dimora",
    d: "Casa, abitazione; famiglia, casata; tempio.",
    u: "Usato 2055 volte nell'AT. La casa del Signore.",
    e: "Da בָּנָה (banah) = costruire"
  },
  "H1254": {
    m: "creare",
    d: "Creare dal nulla; formare, fare; attività esclusiva di Dio.",
    u: "Usato 54 volte nell'AT. Dio creò i cieli e la terra.",
    e: "Radice primaria"
  },
  "H1516": {
    m: "valle, gola",
    d: "Valle, gola, burrone; pianura.",
    u: "Usato 60 volte nell'AT. La valle dell'ombra della morte.",
    e: "Radice primaria"
  },
  "H1878": {
    m: "ingrassare, render grasso",
    d: "Render grasso, ingrassare; prosperare.",
    u: "Usato 11 volte nell'AT. Tu ungi il mio capo con olio.",
    e: "Da דֶּשֶׁן (deshen) = grasso, ceneri"
  },
  "H1980": {
    m: "camminare, andare",
    d: "Camminare, andare, venire; vivere, condursi.",
    u: "Usato 1554 volte nell'AT. Verbo di movimento molto frequente.",
    e: "Radice primaria"
  },
  "H2617": {
    m: "bontà, misericordia, fedeltà",
    d: "Bontà, misericordia; fedeltà all'alleanza; amore leale.",
    u: "Usato 248 volte nell'AT. La bontà del Signore.",
    e: "Da חָסַד (chasad) = essere buono, misericordioso"
  },
  "H2637": {
    m: "mancare, aver bisogno",
    d: "Mancare di, aver bisogno; diminuire, far difetto.",
    u: "Usato 23 volte nell'AT. Non mi mancherà nulla (Sal 23:1).",
    e: "Radice primaria"
  },
  "H2896": {
    m: "buono, bene",
    d: "Buono, piacevole, eccellente; benevolo, giusto.",
    u: "Usato 559 volte nell'AT. Dio vide che era buono.",
    e: "Radice primaria"
  },
  "H3068": {
    m: "YHWH, l'Eterno",
    d: "Il nome proprio di Dio, tetragramma sacro YHWH.",
    u: "Usato 6828 volte nell'AT. Il nome più santo.",
    e: "Da הָיָה (hayah) = essere, esistere"
  },
  "H3117": {
    m: "giorno",
    d: "Giorno (opposto della notte); periodo di 24 ore; epoca, tempo.",
    u: "Usato 2301 volte nell'AT. Il giorno che il Signore ha fatto.",
    e: "Da יוֹם (yowm) = essere caldo"
  },
  "H3372": {
    m: "temere, aver paura, riverire",
    d: "Temere, aver paura; riverire, rispettare Dio.",
    u: "Usato 335 volte nell'AT. Non temo alcun male.",
    e: "Radice primaria"
  },
  "H3563": {
    m: "coppa, calice",
    d: "Coppa, calice; porzione, sorte.",
    u: "Usato 31 volte nell'AT. La mia coppa trabocca.",
    e: "Radice primaria"
  },
  "H3820": {
    m: "cuore, spirito",
    d: "Cuore, sede delle emozioni; spirito, intelligenza, volontà.",
    u: "Usato 598 volte nell'AT. Il cuore dell'uomo.",
    e: "Radice primaria"
  },
  "H3915": {
    m: "notte",
    d: "Notte (opposta al giorno); tempo di oscurità.",
    u: "Usato 234 volte nell'AT. Dio separò il giorno e la notte.",
    e: "Radice primaria"
  },
  "H3966": {
    m: "molto, estremamente",
    d: "Molto, estremamente, assai; con forza, rapidamente.",
    u: "Usato 300 volte nell'AT. Era molto buono.",
    e: "Da מָאַד (ma'ad) = essere numeroso"
  },
  "H4325": {
    m: "acqua, acque",
    d: "Acqua, acque; pioggia; diluvio, mare.",
    u: "Usato 585 volte nell'AT. Le acque della creazione.",
    e: "Duale di מַיִם (mayim) = acqua"
  },
  "H4999": {
    m: "pascolo, dimora",
    d: "Luogo di pascolo, prato; abitazione, dimora.",
    u: "Usato 13 volte nell'AT. In verdi pascoli.",
    e: "Da נָאָה (na'ah) = essere bello, conveniente"
  },
  "H5148": {
    m: "condurre, guidare",
    d: "Condurre, guidare, dirigere; condurre in sicurezza.",
    u: "Usato 40 volte nell'AT. Mi conduce (Sal 23:3).",
    e: "Radice primaria"
  },
  "H5216": {
    m: "pascolo, terra coltivata",
    d: "Prato, pascolo; terra coltivata, campo.",
    u: "Usato 2 volte nell'AT. Pascoli verdeggianti.",
    e: "Da נִיר (niyr) = arare"
  },
  "H5315": {
    m: "anima, vita, persona",
    d: "Anima, vita, essere vivente; persona, sé; desiderio, appetito.",
    u: "Usato 753 volte nell'AT. L'anima mia, la mia vita.",
    e: "Da נָפַשׁ (naphash) = respirare"
  },
  "H5769": {
    m: "eternità, sempre",
    d: "Tempo indefinito, eternità; sempre, perpetuità.",
    u: "Usato 439 volte nell'AT. L'amore eterno di Dio.",
    e: "Da עָלַם (alam) = nascondere, essere nascosto"
  },
  "H6186": {
    m: "disporre, preparare",
    d: "Disporre in ordine, preparare; apparecchiare una tavola.",
    u: "Usato 75 volte nell'AT. Tu prepari una mensa (Sal 23:5).",
    e: "Radice primaria"
  },
  "H6213": {
    m: "fare, compiere",
    d: "Fare, fabbricare, compiere; agire, lavorare.",
    u: "Usato 2632 volte nell'AT. Verbo molto frequente.",
    e: "Radice primaria"
  },
  "H6664": {
    m: "giustizia, rettitudine",
    d: "Giustizia, rettitudine, equità; fedeltà.",
    u: "Usato 119 volte nell'AT. Sentieri di giustizia.",
    e: "Da צָדַק (tsadaq) = essere giusto"
  },
  "H6754": {
    m: "immagine, somiglianza",
    d: "Immagine, somiglianza; forma, apparenza.",
    u: "Usato 17 volte nell'AT. L'uomo creato a immagine di Dio.",
    e: "Da צָלַל (tsalal) = ombreggiare, assomigliare"
  },
  "H6757": {
    m: "ombra della morte, oscurità profonda",
    d: "Tenebre profonde, oscurità mortale; ombra della morte.",
    u: "Usato 18 volte nell'AT. Simbolizza il pericolo estremo.",
    e: "Da צֵל (tsel) = ombra + מָוֶת (maveth) = morte"
  },
  "H6887": {
    m: "essere in angustia, avversario",
    d: "Essere stretto, in angustia; avversario, nemico.",
    u: "Usato 58 volte nell'AT. In presenza dei miei avversari.",
    e: "Radice primaria"
  },
  "H7121": {
    m: "chiamare, gridare, proclamare",
    d: "Chiamare, gridare; nominare; proclamare, convocare.",
    u: "Usato 736 volte nell'AT. Invocare il nome del Signore.",
    e: "Radice primaria"
  },
  "H7200": {
    m: "vedere, guardare",
    d: "Vedere con gli occhi; percepire, comprendere; provvedere.",
    u: "Usato 1311 volte nell'AT. Dio vide che era buono.",
    e: "Radice primaria"
  },
  "H7225": {
    m: "principio, primizie",
    d: "Principio, inizio; il migliore, le primizie.",
    u: "Usato 51 volte nell'AT. 'Nel principio Dio creò...'",
    e: "Da רֹאשׁ (rosh) = capo, principio"
  },
  "H7257": {
    m: "sdraiarsi, riposare",
    d: "Sdraiarsi, riposare; dimorare; covare.",
    u: "Usato 30 volte nell'AT. Mi fa riposare (Sal 23:2).",
    e: "Radice primaria"
  },
  "H7291": {
    m: "inseguire, cacciare",
    d: "Inseguire, cacciare; perseguitare; seguire da vicino.",
    u: "Usato 144 volte nell'AT. La bontà mi seguirà.",
    e: "Radice primaria"
  },
  "H7307": {
    m: "spirito, soffio, vento",
    d: "Soffio, vento; spirito di Dio o dell'uomo; disposizione mentale.",
    u: "Usato 378 volte nell'AT. Lo Spirito di Dio.",
    e: "Da רוּחַ (ruach) = soffiare"
  },
  "H7462": {
    m: "pascolare, pascere, nutrire",
    d: "Far pascolare un gregge; essere pastore; nutrire, curare.",
    u: "Usato 173 volte nell'AT. Il Signore è il mio pastore.",
    e: "Radice primaria"
  },
  "H7549": {
    m: "distesa, firmamento",
    d: "Distesa, volta celeste, firmamento; il cielo.",
    u: "Usato 17 volte nell'AT. La distesa in mezzo alle acque.",
    e: "Da רָקַע (raqa) = stendere, battere"
  },
  "H7626": {
    m: "bastone, tribù",
    d: "Bastone, verga; tribù, ramo familiare.",
    u: "Usato 190 volte nell'AT. Il tuo bastone e il tuo vincastro.",
    e: "Da שָׁבַט (shabat) = ramificare"
  },
  "H7725": {
    m: "ritornare, tornare, restaurare",
    d: "Ritornare, tornare; restaurare, rinnovare; pentirsi.",
    u: "Usato 1058 volte nell'AT. Ristorare l'anima mia.",
    e: "Radice primaria"
  },
  "H7979": {
    m: "tavola",
    d: "Tavola per mangiare; tavola dei pani di presentazione.",
    u: "Usato 71 volte nell'AT. La tavola preparata.",
    e: "Da שָׁלַח (shalach) = inviare, stendere"
  },
  "H8064": {
    m: "cieli, cielo",
    d: "Cieli, firmamento; dimora di Dio; cielo visibile.",
    u: "Usato 420 volte nell'AT. I cieli e la terra.",
    e: "Duale di שָׁמַיִם (shamayim) = altezze"
  },
  "H8414": {
    m: "informe, vuoto, caos",
    d: "Deserto, desolazione; caos, vuoto, nulla.",
    u: "Usato 20 volte nell'AT. La terra era informe e vuota.",
    e: "Da תָּהָה (tahah) = errare"
  }
};

export default strongTranslationsIT;
